import { render, staticRenderFns } from "./ConfigStudent.vue?vue&type=template&id=abfb9f72"
import script from "./ConfigStudent.vue?vue&type=script&lang=js"
export * from "./ConfigStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports